import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { BehaviorSubject, Observable, Subject, firstValueFrom } from "rxjs";
import { ReviewedFilter, TimeFrameFilter } from "./books-review.component";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class BooksReviewService {
  private http = inject(HttpClient);
  private localStorage = inject(LocalStorageService);
  dateSelected$ = new Subject();
  router = inject(Router);

  dateFilter: TimeFrameFilter;
  reviewedFilter: ReviewedFilter;

  companyAccounts: any[] = [];
  companyVendors: any[] = [];
  companyClasses: any[] = [];

  companyAccounts$ = new BehaviorSubject<any[]>([]);
  companyVendors$ = new BehaviorSubject<any[]>([]);
  companyClasses$ = new BehaviorSubject<any[]>([]);

  hasClassesEnabled = false;

  onToolChange$ = new Subject();

  constructor() {
    this.dateFilter = this.localStorage.get("dateFilter") || {
      timeFrame: "this_month",
      startDate: null,
      endDate: null,
    };
    // this.reviewedFilter = this.localStorage.get("reviewedFilter");
  }

  getInconsistencies(companyUuid): Promise<any> {
    return firstValueFrom(
      this.http.get(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/tool/inconsistencies`,
      ),
    );
  }

  getTransactionsWithoutPayee(companyUuid): Promise<any> {
    return firstValueFrom(
      this.http.get(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/tool/transactions-without-payee`,
      ),
    );
  }

  getToolData(companyUuid, tool): Observable<any> {
    console.log("dateFilter from getToolData", this.dateFilter);
    return this.http.post(
      `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/tool/${tool}`,
      {
        startDate: this.dateFilter ? this.dateFilter.startDate : null,
        endDate: this.dateFilter ? this.dateFilter.endDate : null,
        timeFrame: this.dateFilter ? this.dateFilter.timeFrame : null,
        reviewed: this.reviewedFilter ? this.reviewedFilter.value : null,
      },
    );
  }

  updateTransaction(companyUuid, transaction): Promise<any> {
    return firstValueFrom(
      this.http.patch(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/update-transaction`,
        { transaction },
      ),
    );
  }

  markTransactionAsReviewed(
    companyUuid,
    transaction,
    transaction_key,
    toolName,
  ): Promise<any> {
    return firstValueFrom(
      this.http.post(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/review`,
        { transaction, transaction_key, tool_name: toolName },
      ),
    );
  }

  getAiAnalisys(data, companyUuid): Promise<any> {
    return this.http
      .post(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/analyse`,
        data,
      )
      .toPromise();
  }

  getReportDetails(data, companyUuid): Promise<any> {
    return this.http
      .post(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/report-details`,
        data,
      )
      .toPromise();
  }

  createClientTask(data, companyUuid): Promise<any> {
    return this.http
      .post(
        `${environment.apiUrl}/integration/quickbooks/booksreview/${companyUuid}/receipt-request`,
        { integration_data: data },
      )
      .toPromise();
  }

  goToQuickBooks(id, type): void {
    const transactionTypeMapToUrl = {
      Invoice: "invoice",
      Check: "check",
      Payment: "recvpayment",
      Expense: "expense",
      Deposit: "deposit",
      Refund: "refundreceipt",
      Bill: "bill",
      "Bill Payment (Credit Card)": "billpaymentcc",
      "Bill Payment (Check)": "billpayment",
      "Credit Card Expense": "creditcardexpense",
      "Credit Card Credit": "creditcardcredit",
      "Inventory Qty Adjust": "inventory_qty_adjust",
      "Journal Entry": "journal",
      "Cash Expense": "cashexpense",
      "Sales Receipt": "salesreceipt",
    };
    const url = transactionTypeMapToUrl[type] ?? "expense";
    window.open(
      `https://app.qbo.intuit.com/app/${url}?txnId=${id}
    `,
      "_blank",
    );
  }
}
